import { HashLink as Link } from "react-router-hash-link";

const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="title-about">
        <h3>À propos</h3>
        <h2>UN CABINET D'AVOCATS AU SERVICE DES BANQUES</h2>
      </div>
      <div className="about-content">
        <aside>
          <h4 className="text-blue">Droit bancaire - Contentieux financiers</h4>
          <p>
            Une expertise solide au service des banques et institutions
            financières.
            <br />
            <br />
            Dans un environnement juridique en constante évolution, les
            établissements bancaires doivent faire face à de nombreuses
            problématiques dans une matière d'ordre public, où le Juge peut
            soulever d'office de nombreux moyens de droit. Ces enjeux
            nécessitent une anticipation dès le stade de l'assignation.
            <br />
            <br />
            Le cabinet LexiCredis se distingue par sa maîtrise approfondie des
            enjeux spécifiques au secteur bancaire, ainsi que par son approche
            pragmatique et rigoureuse.
          </p>
          <Link to="/#contact" className="btn-empty">
            Nous contacter
          </Link>
        </aside>
        <img className="about-img" src={require("../../assets/img/illu/illu02.webp")} alt="" />
      </div>
    </section>
  );
};

export default About;
